<template>
    <div class="ekma">
        <div class="ekmaChoose">
            <van-collapse v-model="activeNames" @change="collapseChange">
                <van-collapse-item
                        title="条件选择"
                        name="1"
                >
                    <div class="choose">
                        <van-field
                                :columns="siteColumns"
                                readonly
                                clickable
                                label="站点"
                                :value="siteValue"
                                placeholder="选择站点"
                                @click="showSitePicker = true" />
                    </div>
                    <div class="choose">
                        <van-field
                                readonly
                                clickable
                                label="时间"
                                :value="timeValue"
                                placeholder="选择开始时间"
                                @click="showPicker = true"
                        />
                    </div>
                    <div class="choose">
                        <van-button type="info" size="small" @click="searchEkmaData">查询</van-button>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
        <div class="ekmaAllData" >
            <div class="ekmaImgDesc" v-show="ekmaImgShow">
                <div class="ekmaImgTitle">EKMA</div>
                <!-- ekma图片显示 -->
                <div class="ekmaImg">
                    <img :src="ekmaImg" alt="图片丢失" class="imgShow">
                </div>

                <!-- ekma图片文字说明 -->
                <div class="ekmaDesc" v-html="ekmaDesc"></div>
            </div>

            <!-- ekma图表显示 -->
            <div class="ekmaChart">
                <div class="ekmaChartData" :key="index" v-for="(item,index) in paramsType">
                    <div class="ekmaChartTitle">{{item.name}}</div>
                    <div class="chartShow" :id="item.type" ></div>
                </div>
            </div>
        </div>

        <!-- 时间选择弹出层 -->
        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                    show-toolbar
                    v-model="startCurrentDate"
                    type="date"
                    :max-date="maxDate"
                    @cancel="showStartPicker = false"
                    @confirm="onTimeChange"
            />
        </van-popup>
        <van-popup v-model="showSitePicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="siteColumns"
                    @cancel="showSitePicker = false"
                    @confirm="onSiteChange"
            />
        </van-popup>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import $ from 'jquery'
    import {formatDate} from '../assets/date.js';
    export default {
        name: '',
        data () {
            return {
                showPicker:false,
                minHour: 10,
                maxHour: 20,
                maxDate: new Date(),
                startCurrentDate: new Date(),
                timeValue:'',
                myChart:null,
                activeNames:["1"],
                showSitePicker:false,
                siteValue: '',
                siteColumns: [],
                siteInsArr:[],
                insIndex:-1,
                ekmaImg:'',
                ekmaImgShow:false,
                paramsType:[{type:'TVOC',name:'TVOC(mg/m3)'},{type:'O3',name:'O3(ug/m3)'},{type:'NO2',name:'NO2(ug/m3)'},{type:'UV',name:'总辐射(w/m3)'}],
                paramsEcharts:{},
                ekmaDesc:'',
            }
        },
        methods: {
            //初始化站点
            initSiteData(){
                let _this=this;
                let localSite=localStorage.getItem('site');
                if(localSite){
                    let localObj=eval('('+localSite+')');
                    if(typeof localObj === "object"){
                        for (let i = 0; i < localObj.length; i ++) {
                            //添加仪器
                            _this.siteInsArr.push(localObj[i].instrument);
                            let insName=localObj[i].site.siteName;
                            _this.siteColumns.push(insName);
                        }
                    }else{
                        _this.getSiteData()
                    }
                }else{
                    _this.getSiteData()
                }
            },
            //初始化站点
            getSiteData(){
                let _this=this;
                let url=_this.apiIp.getSiteData;
                $.ajax({
                    url:url,
                    type:'GET',
                    //contentType: "application/json; charset=utf-8",
                    //data: {'jData':formData,'operatorType':_this.operatorType},
                    //dataType: "json",
                    success:function(result){
                        if(result.IsSuccess){
                            let data=result.Data;
                            if(data){
                                localStorage.setItem('site',data);
                                let siteData=eval('('+data+')');
                                for (let i = 0; i < siteData.length; i ++) {
                                    //添加仪器
                                    _this.siteInsArr.push(siteData[i].instrument);
                                    let insName=siteData[i].site.siteName;
                                    _this.siteColumns.push(insName);
                                }
                            }
                        }
                    },
                    error:function (result) {

                    }
                });
            },
            //站点选择
            onSiteChange(value,index) {
                let _this=this;
                _this.showSitePicker=false;
                _this.siteValue=value;
                _this.insIndex=index;
            },
            //时间选择
            onTimeChange(val){
                let _this=this;
                _this.timeValue = _this.formatDateToStr(val);
                _this.showPicker=false;
            },
            //数据查询
            searchEkmaData(){
                let _this=this;
                if(_this.insIndex === -1 || _this.timeValue === ''){
                    _this.$toast.fail({
                        duration:800,
                        mask:true,
                        message:'请选择查询条件'
                    });
                    return false
                }
                let insData=_this.siteInsArr[_this.insIndex];
                let InsNo=insData.insNo;
                let InsType=insData.insType;
                let timeAt=_this.timeValue+' 00:00:00';
                let url=_this.apiIp.getEkmaData+'?insNo='+InsNo+'&insType='+InsType+'&timeAt='+timeAt;
                let loading=_this.$toast.loading({
                    duration:0,
                    mask: true,
                    message: '加载中...'
                });
                $.ajax({
                    url:url,
                    type:'GET',
                    //contentType: "application/json; charset=utf-8",
                    //data: {'jData':formData,'operatorType':_this.operatorType},
                    //dataType: "json",
                    success:function(result){
                        if(result.IsSuccess){
                            let data=result.Data;
                            if(data){
                                data=data.replace(/\\n/g,' <br>　　');
                                loading.clear();
                                _this.$toast.success({
                                    duration:500,
                                    mask:true,
                                    message:'数据查询完成'
                                });
                                let siteData=eval('('+data+')');
                                _this.ekmaImg=siteData.Image;
                                _this.ekmaDesc=siteData.Description;
                                let ekmaAllData=siteData.Data.Data;
                                let time=ekmaAllData.TimeAt;
                                let ekmaDataArr=ekmaAllData.Value;
                                for (let i = 0; i < ekmaDataArr.length; i ++) {
                                    let paramData=ekmaDataArr[i];
                                    let paramType=ekmaDataArr[i].parameter;
                                    let paramName=paramData.parameterName;
                                    let paramVal=paramData.Value;
                                    let paramSeries=[{name:paramName, type:'line', data:paramVal}];
                                    let chartOption=_this.paramsEcharts[paramType].getOption();
                                    chartOption.xAxis[0].data=time;
                                    chartOption.legend[0].data=paramName;
                                    chartOption.series=paramSeries;
                                    _this.paramsEcharts[paramType].setOption(chartOption,true);
                                }
                                _this.activeNames=[];
                                _this.collapseChange();
                            }else{
                                loading.clear();
                                _this.$toast.fail({
                                    duration:500,
                                    mask:true,
                                    message:'数据查询失败'
                                });
                            }
                        }else{
                            loading.clear();
                            _this.$toast.fail({
                                duration:500,
                                mask:true,
                                message:'数据查询失败'
                            });
                        }
                    },
                    error:function (result) {
                        loading.clear();
                        _this.$toast.fail({
                            duration:500,
                            mask:true,
                            message:'数据查询失败'
                        });
                        console.log(result);
                    }
                });
            },
            //初始化ekma图表
            initEkmaChart(){
                let _this=this;
                let option = {
                    title: {
                        text: '',
                        textStyle:{
                            color:'#FFFFFF',
                        },
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    color:['#1E90FF'],
                    legend: {
                        data:[],
                        textStyle:{
                            color:'#FFFFFF',
                        },
                    },
                    grid: {
                        left: '8%',
                        right: '4%',
                        bottom: '5%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['line', 'bar'],
                                iconStyle:{
                                    color:'#FFF',
                                    borderColor:'#FFF',
                                }
                            },
                        },
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: [],
                        axisLine:{
                            lineStyle:{
                                color:'#FFF'
                            }
                        },
                        axisLabel:{
                            color:'#FFFFFF',
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLine:{
                            lineStyle:{
                                color:'#FFF'
                            }
                        },
                        axisLabel:{
                            color:'#FFFFFF',
                        },
                    },
                    dataZoom: [{
                        type: 'inside',
                        show:false,
                        start: 0,
                        end: 10
                    }, {
                        show:false,
                        start: 0,
                        end: 10,
                    }],
                    series: []
                };
                let paramTypeArr=_this.paramsType;
                for (let i = 0; i < paramTypeArr.length; i ++) {
                    let myChart = echarts.init(document.getElementById(paramTypeArr[i].type));
                    myChart.setOption(option);
                    _this.paramsEcharts[paramTypeArr[i].type]=myChart;
                }
            },
            //form表单显示隐藏
            collapseChange(){
                let _this=this;
                if(_this.ekmaImg === ''){
                    _this.ekmaImgShow=false
                }else{
                    _this.ekmaImgShow=true
                }
                setTimeout(()=>{
                    _this.setEkmaContentHeight();
                },400);
            },
            //设置主体位置高度
            setEkmaContentHeight(){
                let tabbarHeight=$(".van-collapse-item").height();
                let homeHeight=$(".ekma").height();
                let chartHeight=homeHeight-tabbarHeight;
                $(".ekmaAllData").height(chartHeight);
                //$(".ekmaChart").css("top",tabbarHeight);
            },
            //时间格式化
            formatDateToStr: function(date) {
                return formatDate(date, "yyyy-MM-dd");
            },
        },
        mounted() {
            this.initEkmaChart();
            this.initSiteData();
            this.setEkmaContentHeight();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../style/ekma.css";
</style>



// WEBPACK FOOTER //
// src/components/Ekma.vue